<template>
	<div id="variableFormatSelector" >
			<div class="format-content custom-scrollbar-grey">
				<div v-if="variable.type" class="preview-variable-cell">
					<variable-formats 
						style="padding: 6px 20px;"
						:variable="variable"
						:format="format"
						:formatsForMethods="formatsForMethods"
						@format-changed="onFormatChanged"
						@example-result="exampleResult"
						:whitelist="whitelist"
					/>
				</div>
				<div  v-if="variable.description" class="preview-variable-cell var-desc">
					<div class="var-header">{{$t('var-format-selector.description')}}</div>
					<div class="var-text">{{variable.description || $t('var-format-selector.no-desc')}}</div>
				</div>
			</div>
	
	</div>
</template>

<script>
	import EventBus from '@/assets/js/eventBus'
	import VariableFormats from '@/components/VariableFormats'
	import VariableHelpers from '@/assets/js/variableHelpers'
	export default {
		data() {
			return {
			}
		},
		props: {
			variable: {
				type: Object,
				required: true
			},
			format: {
				type: String
			},
			formatsForMethods:Boolean,
			whitelist: Boolean
		},
		computed: {
			variablePrettyName() {
				return VariableHelpers.extractPrettyName(this.variable)
			},
			groups () {
				let splits = this.variable.name.replace('{', '').split('_')
				if (splits.length > 1) return splits.splice(0, splits.length - 1)
				else return [this.$t('var-format-selector.none')]
			}
		},
		methods: {
			onFormatChanged (format) {
				console.log(format)
				this.$emit('format-changed', format)
			},
			exampleResult(example){
				// console.log(example)
				this.$emit('example-result', example)
			}
		},
		watch: {
			// format: {
			// 	immediate: true,
			// 	handler (format) {
					
			// 	}				
			// }
		},
		components: {
			VariableFormats
		}
	}
</script>

<style lang="less">
 #variableFormatSelector {

	.format-content {
		height: 200px;
		overflow: auto;
		// margin: 10px 0;
	}
	
	.preview-variable-cell {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}

		.custom-control.custom-radio:not(:last-child) {
			margin-bottom: 10px;
		}
	}

	.var-header {
		color: #8F979C;
		font-family: 'Roboto', sans-serif;
		font-size: 14px;
		user-select: none;
		padding: 6px 0px;
	}

	.var-text {
		color: #3D464A;
		font-family: 'Roboto', sans-serif;
		font-size: 14px;
		user-select: none;
	}
	.var-desc{
		padding: 6px 20px;
	}
 }
</style>
